
import { get, post } from '../https2.js'


/**
  * 创建下载任务
  * @param {*} data
  * @returns
  */
export const createDownloadTask = (data) => post('/adx/material/createDownloadTask', data)


/**
  * 查看下载任务
  * @param {*} data
  * @returns
  */
export const materialTask = (data) => get('/adx/material/task', data)


/**
  * 查询表格
  * @param {*} data
  * @returns
  */
export const materialList = (data) => post('/adx/material/list', data)



/**
  * 批量按剧名查询素材（核心接口，分页返回）
  * @param {*} data
  * @returns
  */
export const dxjlist = (data) => post('/adx/dxj/list', data)


/**
  * 按短剧ID批量查询素材（分页返回）
  * @param {*} data
  * @returns
  */
export const dxjbyIds = (data) => post('/adx/dxj/byIds', data)


/**
  * 剧名搜索联想（按关键字模糊匹配，返回最近发布的短剧）
  * @param {*} data
  * @returns
  */
export const dxjsearch = (data) => get('/adx/dxj/search', data)


/**
  * 查询支持的排序字段（供前端下拉展示）
  * @param {*} data
  * @returns
  */
export const dxjsortFields = (data) => get('/adx/dxj/sortFields', data)


/**
  * 创建导出任务
  * @param {*} data
  * @returns
  */
export const dxjcreateTask = (data) => post('/adx/dxj/createTask', data)


/**
  * 查询当前登录人的导出任务（分页返回，按创建时间倒序
  * @param {*} data
  * @returns
  */
export const dxjtask = (data) => get('/adx/dxj/task', data)



/**
  * 批量解析原视频链接
  * @param {*} data
  * @returns
  */
export const videoParseparse = (data) => post('/adx/videoParse/parse', data)



/**
  * 批量查询链接的解析结果（只查缓存，不触发上游解析，未解析过的链接标记为未解析
  * @param {*} data
  * @returns
  */
export const videoParsequery = (data) => post('/adx/videoParse/query', data)



/**
  * 解析并下载
  * @param {*} data
  * @returns
  */
export const videoParsecreateDownloadTask = (data) => post('/adx/videoParse/createDownloadTask', data)


/**
  * 查询当前登录人的解析下载任务（分页，）
  * @param {*} data
  * @returns
  */
export const videoParsetask = (data) => get('/adx/videoParse/task', data)



/**
  * 批量提交解析请求（异步）
  * @param {*} data
  * @returns
  */
export const videoParseV2Parse = (data) => post('/adx/videoParseV2/parse', data)


/**
  * 提交导出任务
  * @param {*} data
  * @returns
  */
export const videoParseV2CreateDownloadTask = (data) => post('/adx/videoParseV2/createDownloadTask', data)

/**
  * 查询当前登录人的导出日志（分页，按创建时间倒序）
  * @param {*} data
  * @returns
  */
export const videoParseV2tTask = (data) => get('/adx/videoParseV2/task', data)


/*
  * 查询指定导出任务的明细（仅本人任务可查）
  * @param {*} data
  * @returns
  */
export const videoParseV2TaskItems = (data) => post('/adx/videoParseV2/taskItems', data)



/*
  * 创建监控推送任务。
  * @param {*} data
  * @returns
  */
export const notifyCreateTask = (data) => post('/adx/dxj/notify/createTask', data)



/*
  * 停止监控任务（停止后不再检查、不再推送）
  * @param {*} data
  * @returns
  */
export const notifyStop = (data) => get('/adx/dxj/notify/stop', data)



/*
  * 恢复监控任务（从当前时间起重新开始检查，停用期间的数据不补推）
  * @param {*} data
  * @returns
  */
export const notifyStart = (data) => get('/adx/dxj/notify/start', data)



/*
  * 查询当前登录人的监控任务（分页，按创建时间倒序）。
  * @param {*} data
  * @returns
  */
export const notifyTasks = (data) => get('/adx/dxj/notify/tasks', data)



/*
  * 新素材提示（前端轮询入口，建议每30~60秒调一次）。
  * @param {*} data
  * @returns
  */
export const notifyUnreadCount = (data) => get('/adx/dxj/notify/unreadCount', data)



/*
  * 通知列表
  * @param {*} data
  * @returns
  */
export const notifyMessages= (data) => get('/adx/dxj/notify/messages', data)


/*
  * 全部标记已读（前端进入通知列表或点击"全部已读"时调用）
  * @param {*} data
  * @returns
  */
export const notifyReadAll= (data) => post('/adx/dxj/notify/readAll', data)


